import { ArrowLeftOutlined } from "@ant-design/icons";
import React from "react";
import { Link } from "react-router-dom";

function GoToHome() {
  return (
    <Link
      to="/"
      className="goToHome"
      style={{
        position: "absolute",
        left: "14px",
        top: "14px",
        width: "38px",
        height: "38px",
        borderRadius: "50%",
        background: "#ffffff",
        boxShadow: "0 2px 10px rgba(0, 0, 0, 0.08)",
        border: "1px solid #f1f5f9",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "16px",
        color: "#d9363e",
        zIndex: 100,
        transition: "all 0.2s ease",
      }}
      aria-label="Back to Home"
    >
      <ArrowLeftOutlined />
    </Link>
  );
}

export default GoToHome;
